<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="from-wrap">
          <div class="head-box">
            <div class="list">
              <div
                class="item"
                :class="{ active: avatar === item.avatar_url }"
                v-for="(item, index) in avatarList"
                :key="index"
                @click="avatar = item.avatar_url"
              >
                <div class="item-img">
                  <img :src="item.avatar_url" alt="" />
                </div>
              </div>
            </div>
          </div>          
          <div class="set-btn2">
            <van-button @click="submit()" :loading="isLoading" :disabled="isLoading" loading-text="保 存"  >保 存</van-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Dialog, Field, Toast, Button } from "vant";

Vue.use(Dialog);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Button);

export default {
  name: "user-uploadhead",
  data() {
    return {
      avatarList: [],
      imgIndex: -1,
      avatar: "",
      isLoading:false,
    };
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
    
    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
    });
    this.getUserAvatar({
      success: (res) => {
        console.log(res);
        toastLoading.clear();
        if (res.status == 1) {
          this.avatarList = res.avatarList;
          this.avatar = res.user.avatar;
        } else {
          Toast(res.message);
        }
      },
    });
  },
  methods: {
    ...mapActions({
      updateUserAvatar: "user/updateUserAvatar",
      getUserAvatar: "user/getUserAvatar",
    }),
    
    submit() {
      let that = this;
      if (this.avatar.match(/^\s*$/)) {
        Toast("请选择头像");
        return;
      }
      console.log(this.avatar);
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.isLoading = true;

      let avatar = this.avatar;
      that.updateUserAvatar({
        avatar,
        success: (res) => {
          toastLoading.clear();
          that.isLoading = false;
          console.log(res)
           if (res.status == 1) {                        
            Toast({
              message: '操作成功',
              onOpened:function(){
               that.$router.go(-1);
              }
            });
            
          } else {
            Toast(res.message);
          }          
        },
      });

    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      guid: (state) => state.user.guid,
      security: (state) => state.user.security,
    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.head-box {
  background: #d3d3d3;
  padding: 0.3rem 0.45rem 0.14rem;
  overflow: hidden;
  min-height: 5.43rem;

  .list {
    overflow: hidden;
  }
  .item {
    width: 1.53rem;
    height: 1.53rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    float: left;
    margin-right: 0.16rem;
    margin-bottom: 0.16rem;
    &:nth-child(4n) {
      margin-right: 0;
    }

    &.active {
      background: url(../../../assets/images/user/set/img-border.png) no-repeat
        center;
      background-size: 100%;
    }

    .item-img {
      width: 1.27rem;
      height: 1.27rem;
      border: 0.02rem solid #aaaaaa;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.set-btn {
  margin-top: 1.65rem;
}
.set-btn2 {
  margin-top: 1.65rem;
}
</style>


